import type { Logger } from './interfaces/logger';
import type { LogFormatter } from './log-formatter';

export abstract class LoggerProvider<T> {
  protected constructor(protected readonly logFormatter: LogFormatter<T>) {}

  abstract getLogger(name: string): Logger;
}
